<template>
    <Modal v-if="showModal" modal-title="Login Needed" @close="showModal = false">
        <template v-slot:body>
            <p>You must be authenticated to be able to perform this action. Please login to YaganKar and retry.</p>
        </template>
        <template v-slot:footer>
            <a class="btn btn-primary float-right" href="/login">Go to Login <i class="fa fa-sign-in"></i></a>
        </template>
    </Modal>
</template>

<script>
export default {
    data() {
        return {
            showModal: false
        };
    },

    mounted() {
        window.yagankar.bus.addListener('login-needed', () => {
            this.showModal = true;
        });
    }
};
</script>
